import { BarChart3, Calendar, FileCheck, FileCheck2, Lock, TrendingUp, Users, Wallet } from "lucide-react";
import {
  type ProjectManagementTabId,
  useProjectManagementContext,
} from "../context";

const tabs: Array<{
  id: ProjectManagementTabId;
  label: string;
  icon: JSX.Element;
  requiresActive?: boolean;
}> = [
  {
    id: "planning",
    label: "Perencanaan (RAB)",
    icon: <Calendar size={18} />,
  },
  {
    id: "team",
    label: "Kelola Tim",
    icon: <Users size={18} />,
  },
  {
    id: "execution",
    label: "Pelaksanaan Lapangan",
    icon: <TrendingUp size={18} />,
    requiresActive: true,
  },
  {
    id: "validation",
    label: "Pemeriksaan / Validasi",
    icon: <FileCheck size={18} />,
    requiresActive: true,
  },
  {
    id: "finance",
    label: "Keuangan (Termijn)",
    icon: <Wallet size={18} />,
    requiresActive: true,
  },
  {
    id: "reporting",
    label: "Laporan Final",
    icon: <BarChart3 size={18} />,
    requiresActive: true,
  },
];

const ProjectManagementTabs = () => {
  const { 
    activeTab, 
    setActiveTab,
    activeProjectId,
    userRole,
    handleSaveBaseline,
    handleSaveBaselineDraft,
    handleFinalizeBaseline,
    isRejectedProject,
    isPendingApproval,
    isActiveApproval,
    isProjectActive = true,
  } = useProjectManagementContext();

  return (
    <div className="bg-white rounded-3xl border border-slate-200/90 shadow-sm mb-7 w-full p-2 md:p-2.5">
      <div className="flex gap-2 overflow-x-auto items-center w-full [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden snap-x snap-mandatory">
        {tabs.map((tab) => {
          const isLocked = Boolean(tab.requiresActive) && !isProjectActive;
          const isActive = activeTab === tab.id;

          return (
            <button
              key={tab.id}
              disabled={isLocked}
              title={isLocked ? "Selesaikan & setujui Perencanaan (RAB & Jadwal) terlebih dahulu agar proyek aktif" : undefined}
              onClick={() => {
                if (!isLocked) {
                  setActiveTab(tab.id);
                }
              }}
              className={`snap-start flex items-center gap-2.5 px-4 py-2.5 text-sm font-extrabold rounded-2xl transition-all duration-200 whitespace-nowrap ${
                isLocked
                  ? "opacity-50 cursor-not-allowed text-slate-400 bg-slate-100/70 border border-slate-200/60"
                  : isActive
                  ? "bg-blue-600 text-white shadow-md shadow-blue-500/25 ring-2 ring-blue-500/20"
                  : "bg-slate-50/80 text-slate-600 hover:bg-slate-100 hover:text-slate-900 border border-slate-200/50"
              }`}
            >
              {isLocked ? <Lock size={15} className="text-slate-400 flex-shrink-0" /> : tab.icon}
              
              <span>{tab.label}</span>

              {isLocked && (
                <span className="hidden xl:inline-flex items-center gap-0.5 rounded-full bg-slate-200 px-2 py-0.5 text-[10px] font-extrabold text-slate-500">
                  Terkunci
                </span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ProjectManagementTabs;
